import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SelectionControlBase } from '../selection-control/SelectionControlBase';

const Toggle = ({ className, disabled, ...other }) => {
  const rootClasses = classNames(
    'sui-inline-flex sui-relative sui--z-1 sui-m-1',
    {
      'sui-cursor-pointer': !disabled,
      'sui-cursor-default sui-pointer-events-none sui-opacity-25': disabled,
    },
    className,
  );

  const inputClasses = 'sui-peer sui-absolute sui-cursor-[inherit] sui-opacity-0 sui-h-full sui-w-full sui-p-1 sui-z-10';
  const trackClasses = 'sui-h-6 sui-w-11 sui-rounded-full sui-z-1 sui-transition-colors sui-bg-medium peer-checked:peer-focus-visible:sui-bg-inverse peer-checked:sui-bg-brand peer-hover:sui-ring-4 peer-hover:sui-ring-hover-accent peer-focus-visible:sui-ring-4 peer-focus-visible:sui-ring-focus peer-focus-visible:sui-bg-medium';

  const handleClasses = 'sui-absolute sui-w-5 sui-h-5 sui-m-2px sui-z-0 sui-bg-subtle sui-rounded-full sui-transition-transform peer-checked:sui-translate-x-5 peer-focus-visible:sui-ring-2 peer-focus-visible:sui-ring-active';

  const checkSpan = (
    <>
      <span className={handleClasses} />
      <span className={trackClasses} />
    </>
  );

  const classes = {
    span: rootClasses,
    input: inputClasses,
  };

  return (
    <SelectionControlBase
      type="checkbox"
      classes={classes}
      disabled={disabled}
      checkedIcon={checkSpan}
      uncheckedIcon={checkSpan}
      {...other}
    />
  );
};

Toggle.displayName = 'Toggle';

Toggle.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // eslint-disable-next-line react/forbid-prop-types
  inputAttributes: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

Toggle.defaultProps = {
  checked: undefined,
  className: null,
  defaultChecked: false,
  id: null,
  inputAttributes: null,
  disabled: null,
  onChange: undefined,
  value: undefined,
};

export { Toggle };
